export enum ALERT_TYPE {
  PRIMARY = 'PRIMARY',
  SUCCESS = 'SUCCESS',
  DANGER = 'DANGER',
  WARNING = 'WARNING',
  INFO = 'INFO',
}

export interface Alert {
  isActive: boolean;
  title?: string;
  content?: string;
  component?: any;
  type: ALERT_TYPE;
  containerClass?: string;
  hasCloseButton?: boolean;
}
